<div class="audio-recorder-container">

  <ng-container *ngIf="!(audioBlobUrl|async) && !(isRecording|async)">
    <button  mat-icon-button (click)="start()">
      <mat-icon>mic</mat-icon>
    </button>
    <div>{{'Enregistrer ma réponse'|transloco}}</div>
  </ng-container>

  <ng-container *ngIf="isRecording|async">
    <button  mat-icon-button (click)="stop()">
      <mat-icon>stop</mat-icon>
    </button>
    <div class="recording-indicator">
      {{ 'Enregistrement en cours '|transloco }}...
    </div>
  </ng-container>
  <!-- Audio player -->
  <div *ngIf="audioBlobUrl|async as audio">
    <audio [src]="audio" controls
           oncontextmenu="return false;"
           ondragstart="return false;"
           ondrop="return false;"
           style="-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;"></audio>
  </div>
  <button *ngIf="audioBlobUrl|async" mat-icon-button (click)="eraseAudio()">
    <mat-icon>delete</mat-icon>
  </button>
</div>
<div *ngIf="audioUploadService.isUploading$[question.key] |async" class="recording-indicator">
  {{ 'Validation en cours'|transloco }}...
</div>
<ng-container *ngIf="(surveyViewerService.allFormControlsMarkedAsTouched$|async) || (isTouched|async)">
  <ng-container *ngFor="let msg of (hasError|async)">
    <div class="error-message">
      {{ msg | translateLabel: activeLang }}.
    </div>
  </ng-container>
</ng-container>


